import React from 'react';
import Tippy from '@tippyjs/react';
import './style.scss';

const TooltipIcon = ({ text }: { text: string }) => {
    return (
        <Tippy content={text} className='tippy-vw' appendTo='parent'>
            <button
                className='c-icon c-info-icon tooltip js-tooltip c-icon--[semantic-info]'
                type='button'
                data-tippy-placement='top'
                aria-label='Tooltip icon'
            ></button>
        </Tippy>
    );
};

export default TooltipIcon;
